import changelogMd from "./projectImages/changelog.webp";
import devEx from './projectImages/devex dashboard.webp';
import devTo from "./projectImages/devto.webp";
import intellistore from "./projectImages/intellistore.webp";
import silver from "./projectImages/website-template.webp";


export const projectImage = {
  changelogMd,
  devTo,
  devEx,
  silver,
  intellistore,
};
